export default __webpack_public_path__ + "74e224d956fe33a4336661e4a778c981.png";